import {IPresenter} from "@/rawdogjs/src/interfaces/IPresenter";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import {RadioTagsView} from "./radioTagsView";
import {Router} from "@/rawdogjs/src/router";


export class RadioTagsPresenter implements IPresenter {

    public _view: RadioTagsView;
    private dependencyContainer: ParcelDependencyContainer;
    private _router: Router;
    
    

    constructor(view: RadioTagsView, router: Router, dependencyContainer: ParcelDependencyContainer) {
        this._view = view;
        this.dependencyContainer = dependencyContainer;
        this._router = router;
    }

    public dataBind(items: Record<string, any>, tagName:string = null){
        this._view.dataBind(items, tagName);
    }


    async initialize() {
        this._view.bind(this, async () => {
        });

        this._view.scrollToTop();
    }

    inject() {
    }

}

